function Italic({ size }: { size: number }) {
  return (
    <svg height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.5 4.5V3H7.25V4.5H12.0155L9.97025 19.5H5V21H16.25V19.5H11.4845L13.5298 4.5H18.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Italic
